module.exports = __webpack_public_path__ + "img/4.dc3259b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.png
// module id = 208
// module chunks = 1